import React from "react";
import { ProcessLink } from "../../global/helpers";
import { storyblokEditable } from "gatsby-source-storyblok";
 
const InsightCard = ({ blok }) => {
  const bgColor = " " + blok.background_color;
  let link = ProcessLink(blok.link);
  return(
    <div {...storyblokEditable(blok)} key={blok._uid} className={"insight-card component " + bgColor} style={{maxWidth :blok.max_width + "px"}}>
        {blok.title.length > 0 && 
            <h3>{blok.title}</h3>
        }
        {blok.description.length > 0 && 
            <p className="description">{blok.description}</p>
        }
        {blok.link.id.length > 0 &&
            <a href={link.url} target={link.target} rel={link.rel} title={link.title} className={"insight-card-link " + link.cssClass} >
                <span>{(link.title.length > 0 ? link.title : blok.link.story.name)}</span>
            </a>
        }
    </div>
  )
};
 
export default InsightCard;